import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { canMatchAuth0Guard, canActivateAuth0Guard } from "@authorization";

import { AccessDeniedComponent } from "./access-denied/access-denied.component";

const routes: Routes = [
    {
        path: "access-denied",
        component: AccessDeniedComponent
    },
    {
        path: "",
        loadChildren: () => import("./authorized/authorized.module").then(m => m.AuthorizedModule),
        canMatch: [canMatchAuth0Guard],
        canActivate: [canActivateAuth0Guard]
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            onSameUrlNavigation: "reload"
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {}
